// Chmod Calculator
export const SET_CHECKED = 'chmod-calculator/set-checked';
export const SET_NUMBER_FIELD_VALUE = 'chmod-calculator/set-number-field-value';
export const SET_TEXT_FIELD_VALUE = 'chmod-calculator/set-text-field-value';

// Epoch Converter
export const SET_UNIX_TIME_INPUT_VALUE = 'epoch-converter/unix-time-form/set-unix-time-input-value';
export const SET_EPOCH_TO_DATE_RESULT = 'epoch-converter/unix-time-form/set-epoch-to-date-result';

export const SET_DATE_TIME_INPUT_VALUE = 'epoch-converter/date-time-form/set-date-time-input-value';
export const SET_DATE_TIMEZONE_INPUT_VALUE = 'epoch-converter/date-time-form/set-timezone-input-value';
export const SET_DATE_TO_EPOCH_RESULT = 'epoch-converter/date-time-form/set-date-to-epoch-result';

export const SET_CURRENT_UNIX_TIME = 'epoch-converter/current-epoch-time/set-current-unix-time';
export const SET_COPY_TO_CLIPBOARD_BUTTON_STATE = 'epoch-converter/current-epoch-time/set-copy-to-clipboard-button-state';

// CrontabGenerator
export const SET_COMMAND_TO_EXECUTE = 'crontab-generator/command-to-execute/set-command-to-execute-value';
export const SET_COMMAND_HAS_ERROR = 'crontab-generator/command-to-execute/set-command-has-error';

export const GENERATE_CRONTAB_LINE = 'crontab-generator/generate-crontab-line/set-result';

export const HOW_TO_HANDLE_OUTPUT = 'crontab-generator/how-to-handle-output/set-how-to-handle-output';
export const SET_PATH_TO_FILE_VALUE = 'crontab-generator/how-to-handle-output/set-path-to-file';
export const SET_EMAIL_VALUE = 'crontab-generator/how-to-handle-output/set-set-email';

export const SET_DAYS_RADIO_BUTTON_VALUE = 'crontab-generator/days/set-radio-button-value';
export const SET_DAYS_OPTION_VALUE = 'crontab-generator/days/set-option-value';
export const SET_DAY_HAS_ERROR = 'crontab-generator/days/set-has-error';

export const SET_HOURS_RADIO_BUTTON_VALUE = 'crontab-generator/hours/set-radio-button-value';
export const SET_HOURS_OPTION_VALUE = 'crontab-generator/hours/set-option-value';
export const SET_HOUR_HAS_ERROR = 'crontab-generator/hours/set-has-error';

export const SET_MINUTES_RADIO_BUTTON_VALUE = 'crontab-generator/minutes/set-radio-button-value';
export const SET_MINUTES_OPTION_VALUE = 'crontab-generator/minutes/set-option-value';
export const SET_MINUTE_HAS_ERROR = 'crontab-generator/minutes/set-has-error';

export const SET_MONTHS_RADIO_BUTTON_VALUE = 'crontab-generator/months/set-radio-button-value';
export const SET_MONTHS_OPTION_VALUE = 'crontab-generator/months/set-option-value';
export const SET_MONTH_HAS_ERROR = 'crontab-generator/months/set-has-error';

export const SET_WEEKDAY_RADIO_BUTTON_VALUE = 'crontab-generator/weekday/set-radio-button-value';
export const SET_WEEKDAY_OPTION_VALUE = 'crontab-generator/weekday/set-option-value';
export const SET_WEEKDAY_HAS_ERROR = 'crontab-generator/weekday/set-has-error';

// PasswordGenerator
export const SET_PASSWORD = 'password-generator/set-password';
export const SET_PASSWORD_LENGTH = 'password-generator/set-password-length';
export const SET_CHECKED_PARAM = 'password-generator/set-checked';
export const SET_COPY_TO_CLIPBOARD_STATE = 'password-generator/set-copy-to-clipboard-state';
